import axios from '../../axiosConfig'
import { tokenConfig } from '../auth'
import {
  FETCH_P_PERFILES_IMAGENES,
  GET_P_PERFILES_IMAGENES,
  GET_P_PERFILES_IMAGENES_ERROR,
} from '../types'

// GET P PERFILES IMAGENES
export const getImagenesPerfiles =
  (codigo_perfil = '', tipo = 'WEB', lista_perfiles = []) =>
  (dispatch, getState) => {
    dispatch({
      type: FETCH_P_PERFILES_IMAGENES,
    })

    let config = tokenConfig(getState)

    if (codigo_perfil == undefined || codigo_perfil == null) codigo_perfil = ''

    if (lista_perfiles.length === 0) {
      axios
        .get(`/perfilesImagenes/?codigo_perfil=${codigo_perfil}&tipo=${tipo}`, config)
        .then(res => {
          dispatch({
            type: GET_P_PERFILES_IMAGENES,
            payload: res.data,
          })
        })
        .catch(err => {
          console.log(err)
        })
    } else {
      let array_perfiles = []

      for (let i = 0; i < lista_perfiles.length; i++) {
        //Hacemos push del valor actual
        array_perfiles.push({
          codigo_perfil: lista_perfiles[i].codigo_perfil,
        })
      }

      const url = `/perfilesImagenes/getImagenesGrupo/`
      const body = JSON.stringify({
        array_perfiles: array_perfiles,
      })

      axios
        .post(url, body, tokenConfig(getState))
        .then(res => {
          dispatch({
            type: GET_P_PERFILES_IMAGENES,
            payload: res.data,
          })
        })
        .catch(err => {
          console.log(err)
          dispatch({
            type: GET_P_PERFILES_IMAGENES_ERROR,
          })
        })
    }
  }
